import React from 'react';
export function DownloadGuideSection() {
  return <section className="py-16 bg-[#F5F7F6]" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="text-center mb-12" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-4" data-id="element-189">
            Small Business Financial Health Check
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-190">
            Is your business financially healthy? Download our free guide to
            assess your financial practices and identify areas for improvement.
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-191">
          <div className="md:w-1/2" data-id="element-192">
            <iframe src="https://preview.mailerlite.io/forms/1833129/167181535604114950/share" style={{
            width: '100%',
            height: '500px',
            border: 'none'
          }} title="Small Business Financial Health Check Form" data-id="element-193"></iframe>
          </div>
          <div className="md:w-1/2 flex justify-center items-center" data-id="element-194">
            <div className="relative transform transition-transform hover:scale-105" style={{
            maxHeight: '500px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-195">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mKWw4WbfTfDmpU647Smqo5/Small_Business_Finance_Health_Check_%281%29.png" alt="Small Business Financial Health Check Guide" className="rounded-lg relative z-10" style={{
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
              transform: 'rotate(2deg)',
              maxHeight: '450px',
              width: 'auto'
            }} data-id="element-196" />
              {/* Magazine shadow effect */}
              <div className="absolute inset-0 rounded-lg bg-gray-800 z-0" style={{
              transform: 'rotate(-1deg) scale(0.98)',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.2)'
            }} data-id="element-197"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}